"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Element = /** @class */ (function () {
    function Element(data) {
        /**
         * Array of options if the field has some
         */
        this.options = [];
        Object.assign(this, data);
    }
    return Element;
}());
exports.Element = Element;
//# sourceMappingURL=element.class.js.map